$(document).ready(function(){


    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) { // Esc
            var nav_span = $(".nav-span");
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps
            $('#searchContainer').removeClass("active");
            $('.header-overlay').hide();  
            $('#protectedDownloadsModal').modal('hide');
        }
    });

    if ($('.fancybox').length)
    {
        $(".fancybox").fancybox(
        {
            openEffect: "none",
            closeEffect: "none"
        });
    }

    /*AOS.init({
        duration: 350,
    });*/



    // orange first words
    $('h1.fancy-title, h2.block-title, h3.block-title, h2.card-title, .filter-label').html(function(i, h)
    {
        if ($(this).children().length > 0 )
        {
            return h;
        }
        // h2.block-title a, h3.block-title a,
        {
            return h.replace(/ (.*)/, " <strong>$1</strong>");
        }
    });

    // get the correct background for footer indent

    let lastContentBlock = $('#mainContentStart').find('.block').last().data('bg-color');

    if (lastContentBlock)
    {
        let insertThis = "use-" + lastContentBlock;
        $("footer").addClass(insertThis);
    }

    


});